

















import Vue from "vue";
import TableComplement from "@/components/Table/Complement/TableComplement.vue";
import CardTitle from "@/components/Text/Card/CardTitle.vue";
import LogsTable from "@/components/Table/Logs/LogsTable.vue";

export default Vue.extend({
  name: "Logs",
  components: { CardTitle, TableComplement, LogsTable },
  data() {
    return {
      selected: []
    };
  }
});
